module.exports = __webpack_public_path__ + "static/media/logo-perfil.782adc2b.png";